import Vue from 'vue';
import Vuex from 'vuex';
import VueResource from 'vue-resource';

import router from './router';
// import user from "@/api/user";
import device from '@/api/device';
// import dispatcher from "@/api/dispatcher";
// import tariff from "@/api/tariff";

import common from '@/store/common';
import dispatcher from '@/store/dispatcher';
import balance from '@/store/balance';
import tariff from '@/store/tariff';
import notifications from '@/store/notifications';

Vue.use(Vuex);
Vue.use(VueResource);

export default new Vuex.Store({
    modules: {
        common,
        dispatcher,
        balance,
        tariff,
        notifications,
    },

    state: {
        idToken: null,
        userId: null,
        user: null,
        serverError: null,
        showRecoveryForm: true,
        showRecoverySuccess: false,
        showNavbar: true,
        // showDispatcherNavbar: false,
        devices: [],
        preloader: false,
    },

    getters: {
        showRecoveryForm: (state) => {
            return state.common.showRecoveryForm;
        },

        showRecoverySuccess: (state) => {
            return state.common.showRecoverySuccess;
        },
    },

    mutations: {
        // SET_USER(state, payload) {
        // 	state.user = payload;
        // },

        // AUTH_USER(state, userData) {
        // 	state.idToken = userData.token;

        // 	state.userId = userData.userId;
        // },

        // CLEAR_AUT_DATA(state) {
        // 	state.idToken = null;
        // 	state.userId = null;
        // },

        SHOW_RECOVERY_SUCCES(email) {
            state.showRecoveryForm = false;
            state.showRecoverySuccess = true;
        },

        CLEAR_SERVER_ERROR(state) {
            state.serverError = null;
        },

        USER_DEVICES: (state, payload) => {
            return (state.devices = payload);
        },
    },

    actions: {
        // signUserUp(context, payload) {
        // 	user
        // 		.create(payload)
        // 		.then(response => {
        // 			const user = {
        // 				id: user.uid
        // 			};
        // 			context.commit("SET_USER", user);
        // 			alert("Регистрация прошла успешно!");

        // 			context.dispatch("setLogoutTimer", response.data.expiresIn);
        // 		})
        // 		.catch(error => {
        // 			console.log(error);
        // 		});
        // },

        // signUserIn(context, payload) {
        // 	user
        // 		.signin(payload)
        // 		.then(response => {
        // 			// const now = new Date()
        // 			// const expirationDate = new Date(now.getTime() + response.data.expiresIn * 1000)
        // 			localStorage.setItem("user", JSON.stringify(response.body));
        // 			// localStorage.setItem('userId', response.data.localId)
        // 			// localStorage.setItem('expirationDate', expirationDate)

        // 			// context.commit('AUTH_USER', {
        // 			//   token: response.data.idToken,
        // 			//   userId: response.data.localId
        // 			// })

        // 			// context.dispatch('setLogoutTimer', response.data.expiresIn)
        // 			router.replace("/balance");
        // 		})
        // 		.catch(error => {
        // 			console.log(error.body);
        // 			this.state.serverError = error.body.error;
        // 		});
        // },

        // // recovery user password via email
        recoveryPasswordEmail(context, payload) {
            user.pswdEmailRecovery(payload)
                .then((response) => {
                    context.commit('SHOW_RECOVERY_SUCCES', response);
                })
                .catch((error) => {
                    console.log('Error:', error);
                    // this.state.serverError =
                    // 	"Электронная почта указанного аккаунта не верифицирована. Восстановление невозможно. Авторизационные данные указаны в приложении к вашему договору.";
                });
        },

        // tryAutoLogin({ commit }) {
        // 	const token = localStorage.getItem("token");
        // 	if (!token) {
        // 		return;
        // 	}
        // 	const expirationDate = localStorage.getItem("expirationDate");
        // 	const now = new Date();
        // 	if (now >= expirationDate) {
        // 		return;
        // 	}
        // 	const userId = localStorage.getItem("userId");
        // 	commit("AUTH_USER", {
        // 		token: token,
        // 		userId: userId
        // 	});
        // },

        // setLogoutTimer({ commit }, expirationTime) {
        // 	setTimeout(() => {
        // 		commit("CLEAR_AUT_DATA");
        // 	}, expirationTime * 1000);
        // 	router.replace("/");
        // },

        getDevices: (context) => {
            device
                .fetchDevices()

                .then((response) => {
                    context.commit('USER_DEVICES', response);
                })

                .catch((reject) => {
                    console.log(reject);
                });
        },

        addDevice: (context, newDevice) => {
            device.sendDevice(newDevice).then().catch();
        },

        deleteDevice: (context, id) => {
            device
                .fetchDevices(id)
                .then((response) => {})

                .catch((reject) => {
                    console.log(reject);
                });
        },

        clearServerError: function ({ commit }) {
            if (this.state.serverError) {
                commit('CLEAR_SERVER_ERROR');
            }
        },

        // getUser: context => {
        // 	user
        // 		.fetchUser()
        // 		.then(response => {})

        // 		.catch(reject => {
        // 			console.log(reject);
        // 		});
        // }

        // getTariffList: context => {
        // 	tariff
        // 		.fetchList()
        // 		.then(res => {})
        // 		.catch(error => {});
        // }
    },
});
